import React from 'react'
import { Carousel, Card } from 'react-bootstrap';
import "./HomePage.css"

export const HomePage = () => {

    return (
        <div className="carouselImage">
        <Carousel>
            <Carousel.Item>
            <img
           className="slides d-block w-100"
           
           src="https://firebasestorage.googleapis.com/v0/b/sivakasi-nadars.appspot.com/o/WebAssets%2Fschool-picture.jpg?alt=media&token=66da4001-e777-4a9f-a95d-7b171528a539"
           alt="First slide"
             />
           </Carousel.Item>
            <Carousel.Item>
            <img
           className="slides d-block w-100"
           src="https://scontent.fixm2-1.fna.fbcdn.net/v/t31.0-8/1052166_221669401329388_928469304_o.jpg?_nc_cat=110&ccb=1-3&_nc_sid=174925&_nc_ohc=p8eT6rkUFZEAX_Bff3c&_nc_ht=scontent.fixm2-1.fna&oh=fd32af80dd6ca91bc100b707b63ba49d&oe=606B11B5"
           alt="Second slide"
             />
           </Carousel.Item>
           <Carousel.Item>
            <img
           className="slides d-block w-100"
           src="https://content.jdmagicbox.com/comp/madurai/j2/0452px452.x452.140203144606.b5j2/catalogue/sivakasi-nadar-matriculation-higher-secondary-school-ellis-nagar-madurai-college-mba-hospitality-management-2mtjdbc.jpg"
           alt="Third slide"
             />
              </Carousel.Item>

              <Carousel.Item>
                 <img
                className="slides d-block w-100"
                src="https://firebasestorage.googleapis.com/v0/b/sivakasi-nadars.appspot.com/o/WebAssets%2Fschool-arc.jpg?alt=media&token=c13a9410-83a9-4a14-9a70-2f37009ad157"
                alt="Third slide"
                  />
              </Carousel.Item>

              <Carousel.Item>
                 <img
                className="slides d-block w-100"
                src="https://content.jdmagicbox.com/comp/madurai/j2/0452px452.x452.140203144606.b5j2/catalogue/sivakasi-nadar-matriculation-higher-secondary-school-ellis-nagar-madurai-college-mba-hospitality-management-27wemja.jpg"
                alt="Third slide"
                  />
              </Carousel.Item>
            </Carousel>

            <div className="cardsContainer">
               <Card style={{maxWidth: 500, marginTop: 2 + 'rem'}} className="card-1">
                <img className="imageCard-1" style={{objectFit: 'fill', height: 300 + 'px'}} variant="top" src="https://firebasestorage.googleapis.com/v0/b/sivakasi-nadars.appspot.com/o/WebAssets%2FSchool%20app%20celeb%20photo.jpg?alt=media&token=6e1b9e06-0c5c-4014-afaa-3bb267026243" />
                <div className="textMiddle-1">
                 <div className="text-1">We Support Innovation</div>
                </div>
              </Card>

              <Card style={{maxWidth: 500, marginTop: 2 + 'rem'}} className="card-2">
                <img className="imageCard-2" style={{objectFit: 'fill', height: 300 + 'px'}} variant="top" src="https://content.jdmagicbox.com/comp/madurai/j2/0452px452.x452.140203144606.b5j2/catalogue/sivakasi-nadar-matriculation-higher-secondary-school-ellis-nagar-madurai-college-mba-hospitality-management-27wemja.jpg" />
                <div className="textMiddle-2">
                 <div className="text-2">Sports & Games</div>
                </div>
              </Card>

              <Card style={{maxWidth: 500, marginTop: 2 + 'rem'}} className="card-3">
                <img className="imageCard-3" style={{objectFit: 'fill', height: 300 + 'px'}} variant="top" src="https://hvchemical.com/wp-content/uploads/2018/11/Hi-Valley-Chemical_Tips-to-Build-Efficient-Science-Laboratory-in-Schools_IMAGE1.jpg" />
                <div className="textMiddle-3">
                 <div className="text-3">Scientist lab</div>
                </div>
              </Card>
              
              <Card style={{maxWidth: 500, marginTop: 2 + 'rem'}} className="card-3">
                <img className="imageCard-3" style={{objectFit: 'fill', height: 300 + 'px'}} variant="top" src="http://www.ppshmr.in/wp-content/uploads/2019/10/digital-smart-classes.jpg" />
                <div className="textMiddle-3">
                 <div className="text-3">Smart Class</div>
                </div>
              </Card>
          </div> 

          <div className="missionContainer" >
            <div className="missionText">
            <div className="textMission-1" style={{textAlign:'left'}}>Learn to Lead</div>
            
            </div>
            
          </div>

          <div style={{margin: 2 + 'rem'}} className="socialLinksContainer">
            <h2>Socials:</h2>
            <div style={{textAlign: 'center'}} className="socialLinks">
             <a href="https://www.justdial.com/Madurai/Sivakasi-Nadar-Matriculation-Higher-Secondary-School-Girls-High-School-Ellis-Nagar/0452PX452-X452-140203144606-B5J2_BZDET" target="_blank"><img width="200" src="https://firebasestorage.googleapis.com/v0/b/sivakasi-nadars.appspot.com/o/WebAssets%2Fjust%20dial.png?alt=media&token=34d10583-1d59-4fd8-8f23-b3e55aea2bed" /></a>
             <a href="https://play.google.com/store/apps/details?id=com.sivanars.flutter&hl=en_IN&gl=US" target="_blank"><img  width="200" src="https://firebasestorage.googleapis.com/v0/b/sivakasi-nadars.appspot.com/o/WebAssets%2FGoogle_Play_Store_badge_EN.png?alt=media&token=58f65fad-f710-48f8-8e92-98945d0975e5" /></a>
             <a href="https://www.facebook.com/Sivanars/" target="_blank"><img  width="100" src="https://firebasestorage.googleapis.com/v0/b/sivakasi-nadars.appspot.com/o/WebAssets%2FFacebook_Logo.png?alt=media&token=49b5d086-dca0-494d-83d6-65cc34298d5a" /></a>
            </div>
          </div> 

    </div>
    )
}